
import { defineComponent } from "vue";
import { HeartIcon } from "@heroicons/vue/outline";
import AppEtherIcon from "@/common/components/Icon/AppEtherIcon.vue";
import AppButton from "@/common/components/AppButton.vue";

export default defineComponent({
  components: {
    AppButton,
    AppEtherIcon,
    HeartIcon,
  },
  props: {
    token: {
      type: Object,
      required: true,
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },
});
